import React from 'react'

import { withStyles, makeStyles } from '@material-ui/core/styles'

import clsx from 'clsx'

import {
    COLOR
} from '../../business-const/Color/Color'

import { 
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from '@material-ui/core'



const useStyles = makeStyles(({ palette, ...theme }) => ({
    tableExibeDados: {
        '& small': {
            height: 15,
            width: 50,
            borderRadius: 500,
            boxShadow:
                '0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24)',
        },
        '& td': {
            borderBottom: '0.5px',
        },
        '& td:first-child': {
            //paddingLeft: '16px !important', // mudança da fonte: estava colocando espaço a esqueda da primeira coluna nos dados
        },
    },
    tableExibeDadosTabela: {
        '& small': {
            height: 15,
            width: 50,
            borderRadius: 500,
            boxShadow:
                '0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24)',
        },
        '& td': {
            borderBottom: '0.5px',
        },
        '& td:first-child': {
            paddingLeft: '16px !important',
        },
    },
}))

const StyledTableRowBodyExibeDados = withStyles((theme) => ({
    root: {
      //'&:nth-of-type(odd)': {
      '&:nth-of-type(even)': {
        backgroundColor: COLOR().bgTabelasLinhasPares,
      },
    },
}))(TableRow);

const StyledTableRowBodyExibeDadosReport = withStyles((theme) => ({
    root: {
      //'&:nth-of-type(odd)': {
      '&:nth-of-type(even)': {
        backgroundColor: COLOR().bgTabelasLinhasParesReport,
      },
    },
}))(TableRow);



export const TableExibeDados = props => {

    const { report, noMinW, ...rest } = props
    
    const classes = useStyles()

    return (
        <div
            className={report ? '' : 'scroll-y max-h-600'} // mudança fixar cabeçalho
        >
            <Table 
                className={clsx('whitespace-pre', noMinW ? '' : report ? 'min-w-800' : 'min-w-960', classes.tableExibeDados)}
                //style={{borderLeft: '0.5px outset', borderRight: '0.5px outset', borderBottom: '0.5px outset'}} // mudança da fonte: retirou borda => mudança fixar cabeçalho retornou
                style={{borderLeft: '0px outset', borderRight: '0px outset', borderBottom: '0px outset'}} // mudança da fonte: retirou borda => mudança fixar cabeçalho retornou
                {...rest}
            />
        </div>
    )
}

export const TableHeadExibeDados = props => {

    const { report, /*popup,*/ ...rest } = props

    return (
        <TableHead
            //className={} 
            className={
                clsx(
                    //report || popup ? 'bg-tableHeadExibeDadosReportPopup' : 'bg-tableHeadExibeDados', // mudança da fonte: retirou background => retornou mudança fixar cabeçalho
                    report ? 'bg-tabelasCabecalhoReport' : 'bg-tabelasCabecalho', // mudança da fonte: retirou background => retornou mudança fixar cabeçalho
                    report ? '' : 'top0-sticky' // mudança fixar cabeçalho
                )
            }
            //style={{borderTop: '2px outset', borderBottom: '2px outset'}} // mudança da fonte: borderBottom: '0.0px outset', incluiu borderTop
            style={{borderTop: '1px outset', borderBottom: '1px outset'}} // mudança da fonte: borderBottom: '0.0px outset', incluiu borderTop
            {...rest}
        />
    )
}

export const TableRowHeadExibeDados = props => {

    const { dados, ...rest } = props

    return (
        <TableRow
            className='align-bottom' // mudança da fonte
        >
            {dados?.map((item, ind) => (
                <TableCellHeadExibeDados
                    key={ind}
                    dados={item}
                    {...rest}
                />
            ))}
        </TableRow>
    )
}

export const TableCellHeadExibeDados = props => {

    const { dados, ...rest } = props

    return (
        <TableCell 
            className="px-0 p-1"
            //style={report ? {borderTop: '2px outset', borderBottom: '2px outset'} : {}} // mudança da fonte: borderBottom: '0.0px outset', incluiu borderTop
            //style={{borderLeft: '1.1px outset', borderRight: '1.1px outset', borderBottom: '1.1px outset'}}
            style={{borderLeft: '0px outset', borderRight: '0px outset', borderBottom: '0px outset'}}
            colSpan={dados.colSpan}
            {...rest}
        >
            {props.dados.headTitle}
        </TableCell>
    )
}

export const TableBodyExibeDados = props => {
    return (
        <TableBody
            {...props}
        />
    )
}

export const TableRowBodyExibeDados = props => {

    const { report, /*popup,*/ ...rest } = props

    return (
        report
            ?
                <StyledTableRowBodyExibeDadosReport
                    className="position-relative"
                    {...rest}
                />
            :
                <StyledTableRowBodyExibeDados
                    className="position-relative"
                    {...rest}
                />
    )
}

export const TableCellBodyExibeDados = props => {
    const { primeiraColuna, bold, espacoReduzido, ...rest } = props

    return (
        <TableCell
            className={(espacoReduzido ? "px-1 p-0" : "px-0 p-1") + (bold ? ' bg-bold' : '') /*+ (primeiraColuna ? ' bg-tableHeadExibeDados' : '')*/}
            //style={{borderLeft: primeiraColuna ? '' : '0.5px outset', borderRight: '0.0px outset', borderBottom: '0.0px outset'}}
            //style={{borderLeft: primeiraColuna ? '1px outset' : '1px outset', borderRight: '1x outset', borderBottom: '1px outset'}}
            style={{borderLeft: primeiraColuna ? '0px outset' : '0px outset', borderRight: '0x outset', borderBottom: '0px outset'}}
            align="left"
            {...rest}
        />
    )
}



export const TableExibeTabela = props => {

    const { report, ...rest } = props
    
    const classes = useStyles()

    return (
        <Table 
            className={clsx('whitespace-pre', classes.tableExibeDados)}
            {...rest}
        />
    )
}